import type { CurrentDataModel } from '@records/state/current-data/current-data.model';
import { DataObject } from '@shared/models/data-object.model';

/**
 * Destructure a record object, retrieving the usages array and the record data
 * as part of a new object.
 */
export function processUsages(record: DataObject): Pick<CurrentDataModel, 'usagesInfo' | 'record'> {
  const result = { record: undefined, usagesInfo: undefined };
  if (record != null) {
    const { usages, ...allData } = record;
    result.record = allData;
    result.usagesInfo = usages;
  }
  return result;
}
